import { ajax } from "rxjs/ajax";
import { ActionKeys } from "@focus/services/lib/user/actionTypes";
import { type FocusAjaxError } from "@focus/interfaces";
import { Observable, type Observer, throwError } from "rxjs";
import KeycloakManager from "../services/keycloak";

let addLogoutAction = (action?: object) => {
  console.log(action);
};

/**
 * Epic to handle the ajax 401 errors and reflect the logged out state
 */
export const authErrorEpic = () =>
  Observable.create((observer: Observer<any>) => {
    addLogoutAction = (action) => {
      observer.next(action);
    };
    // create fake unsubcription
    return () => {};
  });

// filter errors of authentication
const interceptAuthError = (error: FocusAjaxError) => {
  if (error.status === 401) {
    addLogoutAction({ type: ActionKeys.UNSET_USER });
  }
  return throwError(() => error);
};

// wrap ajax so it handles authentication errors
import { catchError, map } from "rxjs/operators";

const _ajax = () => {
  function ajaxHandler(args: Parameters<typeof ajax>[0]) {
    const token = KeycloakManager.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      ...(args as any).headers,
    };

    return ajax({
      ...args,
      headers,
    }).pipe(catchError(interceptAuthError));
  }

  ajaxHandler.getJSON = <T>(url: string) => {
    return ajax<T>({
      url,
      method: "GET",
      headers: {
        Authorization: `Bearer ${KeycloakManager.getToken()}`,
      },
      responseType: "json",
    }).pipe(
      // devolver solo el body (.response)
      map((resp) => resp.response),
      catchError(interceptAuthError)
    );
  };

  return ajaxHandler;
};

export default _ajax;
